import validate from "/builds/1tool/leckorter-portal/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/builds/1tool/leckorter-portal/middleware/auth.global.ts";
import legacy_45routes_45global from "/builds/1tool/leckorter-portal/middleware/legacy-routes.global.ts";
import manifest_45route_45rule from "/builds/1tool/leckorter-portal/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  legacy_45routes_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}